export const usersPageTableColumns = [
  {
    title: 'Имя',
    className: 'name',
  },
  {
    title: 'Почта',
    className: 'email',
  },
  {
    title: 'Телефон',
    className: 'phone',
  },
  {
    title: 'Дата',
    className: 'date',
  },
];